import { render, staticRenderFns } from "./project_snapshots.vue?vue&type=template&id=48daea1d&scoped=true&"
import script from "./project_snapshots.vue?vue&type=script&lang=js&"
export * from "./project_snapshots.vue?vue&type=script&lang=js&"
import style0 from "./project_snapshots.vue?vue&type=style&index=0&id=48daea1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48daea1d",
  null
  
)

/* custom blocks */
import block0 from "./project_snapshots.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports